import styled from 'styled-components';

import { mediaBreakpoint } from '../utils/mediaBreakpoint';

const FormHeading = styled.h3`
  &&& {
    ${({ theme }) => theme.TextStyles.span.Text20EmphasisLeft};
    margin: ${({ theme }) =>
        `${theme.Spacing.spacing0x} ${theme.Spacing.spacing0x} ${theme.Spacing.spacing4x}`};
    ${mediaBreakpoint.up('md')} {
        ${({ theme }) => theme.TextStyles.span.Text24EmphasisLeft};
            margin-bottom: ${({ theme }) => theme.Spacing.spacing2x};
    }
  }
`;

export default FormHeading;
